import React, { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";

const NAV_LINKS = [
  { label: "Hakkında", href: "#hakkinda" },
  { label: "Bilgilendirmeler", href: "#borsa-bilgilendirmeleri" },
  { label: "Telegram VIP", href: "#telegram-vip" },
  { label: "S.S.S.", href: "#sss" },
  { label: "İletişim", href: "#iletisim" },
];

export default function Navbar({ telegramUrl }) {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 16);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="main-navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled || open
          ? "bg-[rgba(5,10,31,0.92)] backdrop-blur-xl border-b border-white/5"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-16">
        <div className="flex items-center justify-between h-20">
          <a
            href="#"
            className="flex items-center gap-3 group"
            data-testid="navbar-logo"
          >
            <span className="w-9 h-9 rounded-full border border-[#d4af37]/50 flex items-center justify-center font-serif text-[#d4af37] text-lg">
              D
            </span>
            <div className="leading-tight">
              <div className="font-serif text-[15px] text-white tracking-wide">
                Derya Eliz Yıldız
              </div>
              <div className="text-[10px] tracking-[0.28em] uppercase text-[#94a3b8]">
                Borsa & Piyasa
              </div>
            </div>
          </a>

          <nav className="hidden lg:flex items-center gap-9">
            {NAV_LINKS.map((l) => (
              <a
                key={l.href}
                href={l.href}
                className="text-[13px] tracking-wider uppercase text-[#cbd5e1] hover:text-[#d4af37] transition-colors duration-300"
                data-testid={`nav-link-${l.label.toLowerCase().replace(/[^a-z]/gi, "")}`}
              >
                {l.label}
              </a>
            ))}
          </nav>

          <div className="hidden lg:flex items-center">
            <a
              href={telegramUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="btn-gold px-5 py-2.5 rounded-full text-[13px] inline-flex items-center gap-2"
              data-testid="navbar-telegram-btn"
            >
              <i className="fa-brands fa-telegram" />
              VIP Gruba Katıl
            </a>
          </div>

          <button
            className="lg:hidden text-white p-2"
            onClick={() => setOpen(!open)}
            data-testid="navbar-mobile-toggle"
            aria-label="Menüyü aç"
          >
            {open ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {open && (
          <div
            className="lg:hidden pb-6 pt-2 border-t border-white/5 animate-fade-in bg-[rgba(5,10,31,0.95)] backdrop-blur-xl -mx-6 md:-mx-10 lg:-mx-16 px-6 md:px-10 lg:px-16"
            data-testid="navbar-mobile-menu"
          >
            <div className="flex flex-col gap-1">
              {NAV_LINKS.map((l) => (
                <a
                  key={l.href}
                  href={l.href}
                  onClick={() => setOpen(false)}
                  className="py-3 px-2 text-[14px] tracking-wider uppercase text-[#cbd5e1] hover:text-[#d4af37] border-b border-white/5"
                  data-testid={`mobile-nav-${l.label.toLowerCase().replace(/[^a-z]/gi, "")}`}
                >
                  {l.label}
                </a>
              ))}
              <a
                href={telegramUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="btn-gold mt-4 px-5 py-3 rounded-full text-[13px] inline-flex items-center justify-center gap-2"
                data-testid="mobile-navbar-telegram-btn"
              >
                <i className="fa-brands fa-telegram" />
                VIP Gruba Katıl
              </a>
            </div>
          </div>
        )}
      </div>
    </header>
  );
}
